import { render, staticRenderFns } from "./dockingList.vue?vue&type=template&id=798350a4&scoped=true&"
import script from "./dockingList.vue?vue&type=script&lang=js&"
export * from "./dockingList.vue?vue&type=script&lang=js&"
import style0 from "./dockingList.vue?vue&type=style&index=0&id=798350a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798350a4",
  null
  
)

export default component.exports